import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "../../../redux/reducers/Models";
import { clearString, getCapitalizedWords, getIsValidString, validateEmail, validatePhone } from "@/utils/functions";
import MyDataView from "./view";
import { useNavigate } from "react-router-dom";
import { searchAddress, updateData } from "@/redux/ducks/customer";
import { useEffect, useState } from "react";
import { Props } from "@/pages/register/Models/address";

export default function MyData() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorZipcode, setErrorZipcode] = useState(false);
  const [success, setSuccess] = useState(false);
  const [editable, setEditable] = useState(false);
  const [email, setEmail] = useState(customer?.client?.email ?? "");
  const [phone, setPhone] = useState(customer?.client?.phone?.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3") ?? "");
  const [zipcode, setZipcode] = useState("");
  const [streetName, setStreetName] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [neighborhood, setNeighborhood] = useState("");
  const [neighborId, setNeighborhoodId] = useState("");
  const [city, setCity] = useState("");
  const [cityId, setCityId] = useState("");
  const [state, setState] = useState("");
  const [stateName, setStateName] = useState("");
  const [stateId, setStateId] = useState("");

  const goBack = () => navigate(-1);

  const onChange = (set: (value: string) => void, e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    set(value);
  }

  const getAddress = () => {
    const address = customer?.client?.addresses?.find(address => address?.main) ?? customer?.client?.addresses?.[0];
    return address ?? customer?.client?.addresses?.[0];
  }

  const getIsDisabled = () => {
    const address = getAddress();
    if (zipcode.length < 9
      || !streetName
      || !number || !neighborhood
      || !city || state.length < 2 
      || (
        clearString(zipcode) !== address?.zipcode && (
          !stateName || !state
          || !stateId || !neighborId || !cityId
          )
      )
      || !validateEmail(email)
      || !validatePhone(phone)
      || (
        clearString(zipcode) === address?.zipcode
        && email === customer?.client?.email
        && clearString(phone) === customer?.client?.phone
        && number === address?.number
      )) return true;

    return false;
  }

  const handleSubmit = (success: boolean) => {
    setIsLoading(false);

		if (!success) {
      setError(true);
			return;
		}

    setSuccess(true);
	}

  const submit = () => {
    if (getIsDisabled() || isLoading) return;

    setIsLoading(true);
    setError(false);

    dispatch(
      updateData({
        email: email ?? "",
        birthdate: customer?.client?.birthday ?? "",
        phone: phone ?? "",
        homePhone: getIsValidString(customer?.client?.homePhone) ? customer?.client?.homePhone! : phone ?? "",
        address: {
          type: getAddress()?.type?.name ?? "",
          zipcode: zipcode,
          streetName: streetName,
          number: number,
          neighborhood: neighborhood,
          city: city,
          stateName: state,
          complement: complement ?? "",
        },
        callback: handleSubmit,
      })
    );
  }

  const handleSearchAddress = (success: boolean, address?: Props['address']) => {
    setIsLoading(false);

    if (!success || !getIsValidString(address?.estado)) {
      setErrorZipcode(true);
      setEditable(true);
      return;
    }

    setEditable(!getIsValidString(address?.endereco));

    setStreetName(address?.endereco!);
    setStateId(address?.codigoEstado!);
    setNeighborhoodId(address?.codigoBairro!);
    setCityId(address?.codigoCidade!);
    setNeighborhood(address?.bairro!);
    setCity(address?.cidade!);
    setState(address?.uf!);
    setStateName(address?.estado!);
  }

  useEffect(() => {
    if (zipcode?.length === 9 && !isLoading && clearString(zipcode) !== getAddress()?.zipcode) {
      setErrorZipcode(false);
      setIsLoading(true);

      dispatch(
        searchAddress({
          zipcode: zipcode,
          callback: handleSearchAddress,
        })
      );
    }
  }, [zipcode]);

  useEffect(() => {
    const address = getAddress();

    setZipcode(address?.zipcode?.replace(/^(\d{5})(\d{3})$/, "$1-$2") ?? "");
    setStreetName(getCapitalizedWords(address?.streetName ?? ""));
    setNumber(address?.number ?? "");
    setComplement(address?.complement ?? "");
    setNeighborhood(getCapitalizedWords(address?.neighborhood ?? ""));
    setCity(getCapitalizedWords(address?.city ?? ""));
    setState(address?.state?.name ?? "");
  }, []);

  return <MyDataView
    goBack={goBack}
    customer={customer}
    onChange={onChange}
    submit={submit}
    isDisabled={getIsDisabled()}
    setZipcode={setZipcode}
    setStreetName={setStreetName}
    setNumber={setNumber}
    setComplement={setComplement}
    setNeighborhood={setNeighborhood}
    setCity={setCity}
    setState={setState}
    setPhone={setPhone}
    setEmail={setEmail}
    phone={phone}
    email={email}
    address={{
      zipcode,
      streetName,
      number,
      complement,
      neighborhood,
      city,
      state,
    }}
    error={error}
    isLoading={isLoading}
    editable={editable}
    success={success}
    setError={setError}
    errorZipcode={errorZipcode}
    setErrorZipcode={setErrorZipcode}
    setSuccess={setSuccess}
  />;
}
